import { Component, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { passwordMatch } from 'src/app/pages/user/user.util';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
declare var $;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnChanges, AfterViewInit {
  resetForm: DVFormGroup;
  resendMail: DVFormGroup;
  resetToken: string;
  splitToken = [];
  constructor(
    private authApi: AuthenticationService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.resendMail = new DVFormGroup({
      email: new DVFormControl(null, {
        'Email is required': Validators.required,
        'Email is not in a valid format': Validators.email
      }),
      token: new DVFormControl(null)
    });
  }

  ngOnInit() {
    // this.resetForm.value.token.setValue(String(splitToken[1]))
    // console.log(token)
    this.resetToken = this.route.snapshot.queryParams.token;
    this.resetForm = new DVFormGroup({
      password: new DVFormControl(null, {
        'Password is required': Validators.required,
        'This password must have at least 1 lower case and 1 upper case and ends with special character ': Validators.pattern(
          /[a-zA-Z\d@$!%*?&]{8,30}/
        )
      }),
      password_repeat: new DVFormControl(null, {
        'Repeat password is required': Validators.required
      }),
      token: new DVFormControl(this.resetToken)
    });
    this.resetForm.setAsyncValidators(passwordMatch());
  }

  ngAfterViewInit() {
    $(`[data-toggle='tooltip']`).tooltip();
    $('.preloader').fadeOut();
    $('#to-recover').on('click', function() {
      $('#loginform').slideUp();
      $('#recoverform').fadeIn();
    });
  }
  ngOnChanges() {
    const token = this.router.url;
    this.splitToken = token.split('=');
  }
  resetPassword() {
    delete this.resetForm.value.password_repeat;
    if (this.resetForm.valid) {
      this.authApi.resetPassword(this.resetForm.value).subscribe(
        Response => {
          $('#to-recover').click(function() {
            $('#resendform').hide();
            $('#resetform').fadeIn();
          });
          this.notifier.success('Your Password Has Changed Successfully');
          this.router.navigateByUrl('/login');
        },
        err => {
          if (err.error.errorCode === 'AUTH-004-500') {
            const errorMessage =
              'Unable to update password, please check your email!';
            this.notifier.error(errorMessage);
          }
        }
      );
    } else {
      this.resetForm.forceShowErrors();
    }
  }
  recoverPassword() {
    delete this.resetForm.value.password_repeat;
    delete this.resetForm.value.email;
    if (this.resendMail.valid) {
      this.authApi.resetPassword(this.resendMail.value).subscribe(
        Response => {
          this.notifier.success('Reset Mail Has Sended Successfully');
          this.resetForm.reset();
          $('#to-login').click(function() {
            $('#recoverform').hide();
            $('#loginform').fadeIn();
          });
        },
        err => {
          this.notifier.error('Please Check Your E-mail Address');
        }
      );
    } else {
      this.resendMail.forceShowErrors();
    }
  }
  returnToRecover() {
    $('#to-login').click(function() {
      $('#recoverform').hide();
      $('#loginform').fadeIn();
    });
  }
}
